const HTML_ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&nbsp;': ' ',
};

// Some backend fields (e.g. rich-text assumption name/description) come through as raw HTML —
// this is a read-only summary view, not a rich-text renderer, so we show plain text instead.
export const stripHtmlTags = (value: string): string =>
  value
    .replace(/<[^>]*>/g, '')
    .replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&nbsp;/g, entity => HTML_ENTITIES[entity])
    .trim();

const formatDiffValue = (value: unknown): string => {
  if (value == null || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.map(formatDiffValue).join(', ');
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? '—' : value.toISOString();
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2) ?? '—';
    } catch {
      return '—';
    }
  }
  if (typeof value === 'string') return stripHtmlTags(value) || '—';

  return String(value);
};

export default formatDiffValue;
